import React from 'react'
import { Navigate } from 'react-router-dom'
import { ForbiddenRouteComponent } from './RoutesComponent'
import { type IWppPermissionedComponent, WppPermissionedComponent } from './PermissionedComponent'

export interface IWppPermissionedRoute {
  path: string
  permissions?: IWppPermissionedComponent['permissions']
  redirectPath?: string
  element: React.ReactNode
  fallback?: React.ReactNode
  subscribe?: number
}

export const WppPermissionedRoute: React.FunctionComponent<Omit<IWppPermissionedRoute, 'path'>> = ({
  permissions,
  element,
  redirectPath,
  subscribe,
  fallback = <ForbiddenRouteComponent />
}) => (
  <WppPermissionedComponent
    permissions={permissions}
    fallback={redirectPath ? <Navigate to={redirectPath} /> : fallback}
    subscribe={subscribe}
  >
    {element}
  </WppPermissionedComponent>
)

export default WppPermissionedRoute
